import * as mapping from 'knockout-mapping';
import PriceYourRoom from './priceyourroom';
import PriceYourRoomCarpet from './priceyourroomcarpet';
import Flickity from 'flickity';
import 'flickity-as-nav-for';
import Masonry from 'masonry-layout';
import ko from 'knockout';
import val from '../../val';
import Offcanvas from 'bootstrap/js/src/offcanvas.js';
import Modal from 'bootstrap/js/src/modal.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import * as Ladda from "ladda";
import axios from "axios";
import {Tooltip} from "bootstrap";

declare var grecaptcha: any;

let json = $("#page-data").text();
let crossSellJson = $("#crosssell-data").text();
let crossSellUnderlaysJson = $("#crosssell-underlays").text();
let pricingJson = $("#pricing-data").text();
let productJson = $("#product-data").text();
let catsJson = $("#categories-data").text();

// custom mapping to ensure our input fields are always numeric values and not strings
var myMapping = {
    'RoomSettings': {
        create: function (options) {
            return (new(function () {
                this.UserInputtedM2 =  ko.observable(options.data).extend({numeric: 2, throttle: 220});
                this.AreaWidth =  ko.observable(options.data).extend({numeric: 2});
                this.AreaLength =  ko.observable(options.data).extend({numeric: 2});
                ko.mapping.fromJS(options.data, {}, this);
            })());
        }
    }
}


var data = mapping.fromJSON(json, myMapping);
data.Qty = ko.observable(1);
data.Pricing  = mapping.fromJSON(pricingJson);

var crossSellData = mapping.fromJSON(crossSellJson);
var crossSellUnderlaysData = JSON.parse(crossSellUnderlaysJson);
var productData =JSON.parse(productJson);
var catsData = JSON.parse(catsJson);

var reviewImageFiles = [];

$(async function () {
    
    if (productData.IsRollProduct) {
        await PriceYourRoomCarpet.init(data);
    }
    else if (productData.IsM2Product) {
        await PriceYourRoom.init(data);
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    // @ts-ignore
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
    
    var repositionDescriptionOnMobile = function() {
        if ($(window).width() < 992) {
            $("#productDescription").children().appendTo("#mobileProductDescription");

        } else {
            $("#mobileProductDescription").children().appendTo("#productDescription");

        };
    };
    
    repositionDescriptionOnMobile();
    
    $(window ).on('resize', function() {
        repositionDescriptionOnMobile();
    });
    
    ko.applyBindings(data, $("#root")[0]);
    
    var elem = document.querySelector('.img-carousel');
    var flkty = new Flickity( elem, {
        // options
        cellAlign: 'left',
        contain: true,
        lazy: true,
        on: {
            ready: function() {
                $(".carousel-cell").addClass("pageloaded");
            }
        }
    });

    var subEl = document.getElementsByClassName('img-carousel-sub');
    if (subEl.length > 0) {
        var flktySub = new Flickity('.img-carousel-sub', {
            asNavFor: '.img-carousel',
            contain: true,
            pageDots: false
        });
    }

    var msnEl = document.getElementsByClassName('reviews1');
    if (msnEl.length > 0) {
        var msnry = new Masonry('.reviews1', {
            // options
            gutter: 10
        });
    }
});

$("#addbasket").on('submit',async function (e) {
    e.preventDefault();
    
    $("#btnaddbasket").addClass('disabled');
    
    var id = this.dataset.id;
    var qtyString = $("#Quantity").val();

    if (isNaN(parseInt(qtyString as string)))
        return;
    
    var qty:number = qtyString as number;
    
    var productAttributeData = $(this).attr('data-product');
    var productDataDeserialized = JSON.parse(productAttributeData);
    
    productDataDeserialized.Qty = qty;
    productDataDeserialized.Price = data.Pricing.PriceWithPromo();
    productDataDeserialized.LineTotal = data.Pricing.LineTotal;
    productDataDeserialized.LineDiscount = data.Pricing.LineDiscount;
    productDataDeserialized.BasketFacetValues = mapping.toJS(data.Pricing.FacetValues);
    
    // we need to get cross-selling products in an object
    var inputModel = {
        productId: id,
        basketFacetValues: productDataDeserialized.BasketFacetValues,
        qty: qty,
        crossSellProducts: []
        //variations: getVariants()
    }

    var basketContext = ko.contextFor($("#sideCart")[0]);
    
    for(var i=0; i<crossSellUnderlaysData.length; i++) {
        var underlayCoversM2 = crossSellUnderlaysData[i].MetersSquaredPerItem;
        var totalFloorM2 = data.Pricing.TotalM2ForAllPacks();
        
        var requiredUnderlays = Math.ceil(totalFloorM2 / underlayCoversM2);
        
        crossSellUnderlaysData[i].QtyRequired = requiredUnderlays;
        crossSellUnderlaysData[i].TotalPrice = crossSellUnderlaysData[i].Price * requiredUnderlays;
    }
    if (crossSellUnderlaysData.length > 1) {
        basketContext.$data.SelectedUnderlayId(crossSellUnderlaysData[0].Id);
    }
    
    basketContext.$data.CrossSellUnderlays(crossSellUnderlaysData);
    
    var existing = ko.utils.arrayFirst(basketContext.$data.Basket.Items(), function(item:any) {
        if (item.ProductId() == productDataDeserialized.ProductId && productDataDeserialized.BasketFacetValues.length == 0) {
            return true;
        } else if (item.ProductId() == productDataDeserialized.ProductId && productDataDeserialized.BasketFacetValues.length > 0) {
            // check facet values too
            let combined1 = '';
            for(let i=0; i<item.BasketFacetValues().length; i++){
                combined1 += item.BasketFacetValues()[i].FacetValue();
            }
            let combined2 = '';
            for(let i=0; i<productDataDeserialized.BasketFacetValues.length; i++){
                combined2 += productDataDeserialized.BasketFacetValues[i].FacetValue;
            }
            
            if (combined1 == combined2)
                return true;
        }
    });

    var mappedPr = null;
    if (existing) { 
        var currentQty = parseInt(existing.Qty());
        var newQty = currentQty + parseInt(data.Pricing.Qty());
        existing.Qty(newQty)
        mappedPr = existing;
    }
    else {
        mappedPr = mapping.fromJS(productDataDeserialized);

        // add to our client js first, so its instant   
        basketContext.$data.Basket.Items.push(mappedPr)
    }

    if (crossSellUnderlaysData.length > 0)
        basketContext.$data.itemJustAddedWithUnderlayCrossSellOptions(true);
    mappedPr.QtyAdded = ko.observable(qty);
    
    basketContext.$data.ItemsJustAdded.push(mappedPr)
    
    // set to basket tab
    basketContext.$data.cartTab('cart');
    
    var myOffcanvas = document.getElementById('sideCart')
    var bsOffcanvas = new Offcanvas(myOffcanvas)
    bsOffcanvas.show()

    // cross sell items, need to sort
    for(var i=0; i<crossSellData().length; i++) {
        var qtyEl = $("#CrossSellQty_" + crossSellData()[i].Product.Id());
        var csQtyString = $("#CrossSellQty_" + crossSellData()[i].Product.Id()).val()
        var parentEl = qtyEl.parents("div.cross-sell-product")

        if (isNaN(parseInt(csQtyString as string)))
            csQtyString = 0;
        
        var csQty:number = csQtyString as number;
        
        if (csQty > 0)
        {
            var json = parentEl.attr('data-product');
            var csDeserialized = JSON.parse(json);

            csDeserialized.Qty = csQty;
            csDeserialized.LineTotal = parseFloat(csDeserialized.Price) * csQty;
            csDeserialized.LineDiscount = 0;
            csDeserialized.BasketFacetValues = [];
            var mappedCs = mapping.fromJS(csDeserialized);
            basketContext.$data.Basket.Items.push(mappedCs)
            
            inputModel.crossSellProducts.push({Id: crossSellData()[i].Product.Id(), Qty: csQty})
        }
    }
    
    // pallet mode
    var isPallet = false;
    if (basketContext.$data.Basket.RoomSettings.RoomMode() == '2') {
        inputModel.basketFacetValues.push({FacetId: 0, FacetName: 'Pallet Qty', FacetValue: productData.PalletQty})
        isPallet = true;
    }
    
    try {
        // log to klaviyo
        let baskeItemNames = basketContext.$data.Basket.Items().map(function(item) {
            return item.Name()
        });

        let basketItems = basketContext.$data.Basket.Items().map(function(x) {
            return {
                ProductID: x.ProductId(),
                SKU: ko.unwrap(x.Sku),
                ProductName: x.Name(),
                Quantity: x.Qty(),
                ItemPrice: (x.LineTotal() - x.LineDiscount()) / x.Qty(),
                RowTotal: (x.LineTotal() - x.LineDiscount()),
                ProductURL: "https://www.floordepot.co.uk/item/" + x.ProductId(),
                ImageURL: "https://ik.imagekit.io/floordepot/tr:n-prod_detail_lg/" + x.Media.Filename(),
                Categories: [x.CategoryName()]
            }
        });
        
        let basketTotal = (basketContext.$data.Basket.Total() + (data.Pricing.LineTotal() - data.Pricing.LineDiscount()));
        
        (window as any).klaviyo.track("Added to Cart", {
            "AddedItemProductName": productData.Name,
            "AddedItemProductID": productData.Id,
            "AddedItemSKU": productData.Sku,
            "AddedItemCategories": catsData.map(function (cat) {
                return cat.Name
            }),
            "AddedItemImageURL": "https://ik.imagekit.io/floordepot/tr:n-prod_detail_lg/" + productData.DefaultMedia.Filename,
            "AddedItemURL": "https://www.floordeot.co.uk/item/" + productData.Id,
            "AddedItemPrice": data.Pricing.Price(),
            "AddedItemQuantity": data.Pricing.Qty(),
            "ItemNames": baskeItemNames,
            "CheckoutURL": "https://www.floordepot.co.uk/checkout",
            "Items": basketItems,
            "time": new Date().toISOString(),
            $value: basketTotal,
            value_currency: "GBP",
        }, function (e) {
            console.log("k")
        });
    }
    catch (e) {
        console.log(e);
    }
    
    $("#basket-errors").text('');
    
    try {
        var result = await axios.post(isPallet ? '/basket/addpallet' : '/basket/add', inputModel);
        $("#btnaddbasket").removeClass('disabled');

        // google event
        var item = {
            item_name: productData.Name,
            item_id: productData.Id,
            price: productData.Price,
            item_category: catsData[0].Name,
            quantity: data.Pricing.Qty()
        };
        
        dataLayer.push({ 'ecommerce': null });
        dataLayer.push({
            'event': 'addedToCart',
            'ecommerce': {
                'currency': 'GBP',
                'items': [item]
            }
        });
        
        // check of the DeliveryOptionV2 item exists in our delivery list, if not add it temporarily so we can display it
        var exists = ko.utils.arrayFirst(basketContext.$data.DeliveryOptions(), function(item:any) {
            return item.Id() == result.data.DeliveryOptionV2.Id && item.Cost() == result.data.DeliveryOptionV2.Cost;
        });

        if (exists == null)
        {
            var newDeliveryMapped = mapping.fromJS(result.data.DeliveryOptionV2);
            newDeliveryMapped.Name(newDeliveryMapped.Name() + ' - ' + '£' + newDeliveryMapped.Cost().toFixed(2));
            basketContext.$data.DeliveryOptions.push(newDeliveryMapped);
        }

        mapping.fromJS(result.data, {}, basketContext.$data.Basket);
    }
    catch(err) {
        val.displayErrors(err.response.data, '#basket-errors');
        $("#btnaddbasket").removeClass('disabled');

        if (mappedPr != null) {
            basketContext.$data.Basket.Items.remove(mappedPr);
        }
        if (existing) {
            // reset qty if we have failed for any reason
            existing.Qty(data.Pricing.Qty());
        }

        bsOffcanvas.hide();
    }
});

$("#whatsappForm").on('submit', function(e) {
    e.preventDefault();

    $("#btn-whatsapp").attr('disabled', 'disabled').text('Please Wait...');
    
    var form = $(this);
    var apiKey = $(this).attr('data-gapikey');
    var url = form.attr('action');
    
    grecaptcha.ready(function() {
        grecaptcha.execute(apiKey, { action: 'contact' }).then(function(token) {
            $('#RecaptchaToken').val(token);
            var formData = form.serialize();

            // we want to fire klavio first, so we create an identity, then server side will also fire an event to klaviyo about the photo request event
            (window as any).klaviyo.identify({
                "email" :data.Email(),
                "phone_number": data.TelNumber()
            }, async function(e){
                console.log("Klaviyo identity has been completed");

                try {
                    var result = await axios.post(url, formData);
                    $(".morephotosdone").css('display', 'block');
                    $("#btn-whatsapp").text('Done');
                }
                catch(err) {
                    val.displayErrors(err.response.data);
                    $("#btn-whatsapp").text('Submit').removeAttr('disabled');
                }
            });
        });
    });
})

$("input[name=Score]").on('change', function(e) {
    console.log((e.currentTarget as HTMLInputElement).value)
})

const myModalEl = document.getElementById('leaveReviewModal')
myModalEl.addEventListener('show.bs.modal', async event => {
    
    // lazy load this import, we dont want to load this large file on every page load when it will be used sparingly when leaving a review
    const {create, FilePondFile, registerPlugin} = await import ('filepond');
    registerPlugin(FilePondPluginImagePreview);
    registerPlugin(FilePondPluginFileValidateType);
    registerPlugin(FilePondPluginFileValidateSize);

    const inputElement = document.getElementById("ImageFile")

    // Create a FilePond instance
    const pond = create(inputElement, {
        credits: false,
        allowMultiple: true,
        imagePreviewHeight: 170,
        acceptedFileTypes: ['image/png', 'image/jpeg'],
        labelFileTypeNotAllowed: 'Only image files of .jpg or .png can be uploaded',
        maxFileSize: '5MB',
        labelMaxFileSizeExceeded: 'File size limit exceeded, max file size is 5MB',
        server: {
            url: '/reviews/uploadimg',

            process: {
                url: '',
                ondata: (fd) => {
                    //fd.append('OrderId', data.OrderId());
                    return fd;
                }
            },
            load: async (source, load, error, progress, abort, headers) => {

                var myRequest = new Request(source);
                const response = await fetch(myRequest);
                const blob = await response.blob();
                load(blob);
            },
        },
        onaddfile: function (e, file: FilePondFile) {
            reviewImageFiles.push(file.filename)
        }
    });
})



$("#leaveReviewModal form").on('submit', async function(e) {
    e.preventDefault();
    var url = $(this).attr('action');

    var l = Ladda.create(document.querySelector('#btn-submit-review'));
    l.start();
    
    var p = {
        productId: $("#ProductId").val(),
        score: $("input[name=Score]:checked").val(),
        title: $("#Title").val(),
        content: $("#Content").val(),
        userDisplayName: $("#UserDisplayName").val(),
        reviewerEmail: $("#ReviewerEmail").val(),
        imageUrls: reviewImageFiles
    }

    const myModal = Modal.getOrCreateInstance(document.getElementById('leaveReviewModal'));
    
    try {
        var result = await axios.post(url, p);
        $("#Content").val('');
        $("#Title").val('');

        l.stop();

        myModal.hide();
        $(".review-submitted").removeClass('d-none');
    }
    catch(err) {
        val.displayErrors(err.response.data, '#leaveReviewErrors');
        l.stop();
    }
})